export enum CompetenceTypeEnum {
  TECHNOLOGIES,
  MIDDLEWARE_SOFTWARE,
  FOREIGN_LANGUAGES,
  PROG_LANGUAGES,
  SOFTWARE,
  METHODS,
  PLATFORMS,
  TOOLS,
  TOOLS_MULTIMEDIA,
  DATABASES,
  OPERATING_SYSTEMS,
  HARDWARE,
  TRASHCAN,
  FRAMEWORK,
  DATA_SENDING_TECHNOLOGIES
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/competence-type.enum.ts